export default "__VITE_ASSET__DyndudPm__"